module.exports = __webpack_public_path__ + "static/media/dealOfTheWeekBg.0566e49e.png";